import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ais-ui/ui-core';
import BidirectionalMapChart from './BidirectionalMapChart';
import { useState } from 'react';

interface BidirectionalCardProps {
  imo: number;
}

export const BidirectionalCard = ({ imo }: BidirectionalCardProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('sog');

  return (
    <Card className="col-span-4 p-4">
      <CardHeader className="space-y-8">
        <CardTitle>Vessel AIS (last 24 hours)</CardTitle>
        <Select value={selectedValue} onValueChange={setSelectedValue}>
          <SelectTrigger className="w-[240px] text-md">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="sog">Speed Over Ground</SelectItem>
            <SelectItem value="cog">Course Over Ground</SelectItem>
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent className="pl-2">
        <BidirectionalMapChart
          selectedValue={selectedValue as 'sog' | 'cog'}
          imo={imo}
        />
      </CardContent>
    </Card>
  );
};
